<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="21.5" height="21.5" viewBox="0 0 21.5 21.5">
    <g transform="translate(0.75 0.75)">
      <circle :style="{stroke:color}" class="a" cx="10" cy="10" r="10"/>
      <line :style="{stroke:color}" class="b" x1="6" y2="6" transform="translate(7 7)"/>
      <line :style="{stroke:color}" class="b" x2="6" y2="6" transform="translate(7 7)"/>
    </g>
  </svg>
</template>

<script>
export default {
  name: "DiscardIcon",
  props: {
    color: String
  }
}
</script>

<style scoped>
.a {
  fill: rgba(255, 255, 255, 0);
}

.a, .b {
  stroke: #8ea2a8;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.5px;
}

.b {
  fill: none;
}
</style>
